import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header({ user }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="bg-cyberBlue p-4">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-4xl font-bold transition-colors duration-300">
          <Link to="/" className="text-white transition-all duration-300">
            🔐 UTA CTF
          </Link>
        </h1>

        <div className="md:hidden">
          <button onClick={toggleMenu} className="focus:outline-none">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
            </svg>
          </button>
        </div>

        <nav className={`md:flex ${isOpen ? 'block' : 'hidden'}`}>
          <ul className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-6">
            <li>
              <Link
                to="/"
                className="text-lg font-semibold text-black hover:text-white transition-all duration-300"
                onClick={toggleMenu}
              >
                Home
              </Link>
            </li>
            <li>
              <Link
                to="/challenges"
                className="text-lg font-semibold text-black hover:text-white transition-all duration-300"
                onClick={toggleMenu}
              >
                Challenges
              </Link>
            </li>
            <li>
              <Link
                to="/leaderboard"
                className="text-lg font-semibold text-black hover:text-white transition-all duration-300"
                onClick={toggleMenu}
              >
                Leaderboard
              </Link>
            </li>
            {user ? (  // If user is logged in, show the username
              <li className="text-lg font-semibold text-white">
                Hello, {user.username}
              </li>
            ) : (  // Otherwise, show Login and Signup links
              <>
                <li>
                  <Link
                    to="/signup"
                    className="text-lg font-semibold text-black hover:text-white transition-all duration-300"
                    onClick={toggleMenu}
                  >
                    Signup
                  </Link>
                </li>
                <li>
                  <Link
                    to="/login"
                    className="text-lg font-semibold text-black hover:text-white transition-all duration-300"
                    onClick={toggleMenu}
                  >
                    Login
                  </Link>
                </li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
